<template>
  <section
    id="report"
    class="contact-us-section ptb-100"
    :class="{ 'gray-light-bg': isGray }"
  >
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div class="col-12 col-lg-6">
          <div
            v-if="data"
            class="contact-us-form gray-light-bg rounded p-5 text-center"
          >
            <h4>{{ data.title }}</h4>
            <p>{{ data.description }}</p>
            <!-- <a
              id="btnContactUs"
              type="submit"
              class="btn btn-brand-02 font-weight-bold"
              :href="data.url"
              target="_blank"
            >
              Unduh Template
            </a> -->
            <a
              id="btnContactUs"
              type="submit"
              class="btn btn-success font-weight-bold ml-2"
              :href="data.url"
              target="_blank"
            >
              Panduan
            </a>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <div class="text-center">
            <img
              src="../../assets/img/report-illust.jpg"
              alt="Report illustration"
              style="max-width: 300px"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Report',
  props: {
    isGray: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: null,
      alertText: '',
      hasError: false,
      isSuccess: false
    }
  },
  async mounted() {
    const res = await this.$axios.get(`/company-profile/report`)
    if (res.data[0]) {
      this.data = res.data[0]
    }
  }
}
</script>

<style>
.report-message {
  min-height: 100px;
}
</style>
